const Images ={
    logo:require('../images/logo.png'),
    pfimg:require('../images/pf.png'),
    dummypf:require('../images/dummypf.png'),

}

export default Images;